import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, FileText, Package, History, Building2 } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FiscalConfigCard } from "@/components/fiscal/FiscalConfigCard";
import { TaxRuleList } from "@/components/fiscal/TaxRuleList";
import { ProductFiscalList } from "@/components/fiscal/ProductFiscalList";
import { NfceHistoryList } from "@/components/fiscal/NfceHistoryList";
import { EmitterDataForm } from "@/components/fiscal/EmitterDataForm";
import { FiscalSetupGuide } from "@/components/fiscal/FiscalSetupGuide";

export default function FiscalPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">Fiscal / NFC-e</h1>
          <p className="text-muted-foreground">
            Configure dados fiscais para emissão de NFC-e
          </p>
        </div>
        <FiscalSetupGuide />
      </div>

      <Tabs defaultValue="emitente" className="space-y-6">
        <TabsList className="grid w-full grid-cols-5 lg:w-auto lg:inline-flex">
          <TabsTrigger value="emitente" className="gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">Emitente</span>
          </TabsTrigger>
          <TabsTrigger value="config" className="gap-2">
            <Settings className="h-4 w-4" />
            <span className="hidden sm:inline">Configurações</span>
          </TabsTrigger>
          <TabsTrigger value="regras" className="gap-2">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">Regras Tributárias</span>
          </TabsTrigger>
          <TabsTrigger value="produtos" className="gap-2">
            <Package className="h-4 w-4" />
            <span className="hidden sm:inline">Produtos</span>
          </TabsTrigger>
          <TabsTrigger value="historico" className="gap-2">
            <History className="h-4 w-4" />
            <span className="hidden sm:inline">NFC-e Emitidas</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="emitente">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building2 className="h-5 w-5" />
                Dados Fiscais do Emitente
              </CardTitle>
              <CardDescription>
                Estes dados são usados na emissão de NFC-e e devem corresponder ao certificado digital configurado no ACBrMonitor.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <EmitterDataForm />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="config">
          <FiscalConfigCard />
        </TabsContent>

        <TabsContent value="regras">
          <TaxRuleList />
        </TabsContent>

        <TabsContent value="produtos">
          <ProductFiscalList />
        </TabsContent>

        <TabsContent value="historico">
          <NfceHistoryList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
